export default "__VITE_ASSET__BnRiIfVX__"